import { handleActions } from "redux-actions";
import { setAuthNoAccess } from "../actions/actions";

export default handleActions(
  {
    [setAuthNoAccess]: (state, action) => {
      return action.payload;
    },
  },
  {}
);
